<div class="notification-alerts-container" nz-flex nzJustify="center" nzAlign="center" [nzVertical]="true">
  <ng-container *ngFor="let message of messages">
    <nz-alert [nzCloseable]="message.alertOptions?.closable"
              [nzType]="message.type"
              [nzMessage]="message.text"
              nzShowIcon
              class="mb-8 w-395">
    </nz-alert>
  </ng-container>
</div>

<router-outlet/>


<ng-template #saveErrorTpl>
  <p>An error occurred while saving your application.</p>
  <p>Your data could not be saved at this time. Please refresh the page and try again.</p>
  <p>
    If the issue continues, please contact
    <a href="mailto:itsupport&#64;afsa.kz">itsupport&#64;afsa.kz</a>
    for assistance.
  </p>
</ng-template>
